import type { ReactNode } from 'react'

import { useAuthStore, useMembershipStore, useUserInfoStore } from '@space-shell/core/store'
import { lazyRemote } from '@space-shell/lib/runtime'

const ProductFruitsProvider = lazyRemote('community/ProductFruitsContext', 'ProductFruitsProvider')

type ProductFruitsProviderWrapperProps = {
  children: ReactNode
}

export const ProductFruitsWrapper = ({ children }: ProductFruitsProviderWrapperProps) => {
  const { token } = useAuthStore()
  const { membershipSlug, membershipData } = useMembershipStore()
  const { role: userRole } = useUserInfoStore()

  return (
    <ProductFruitsProvider
      token={token}
      userCustomProps={{
        membershipSlug,
        platform: window.navigator.platform,
        userRole,
        membershipID: membershipData?.slug
      }}>
      {children}
    </ProductFruitsProvider>
  )
}
